/* eslint-disable max-len */
module.exports = {
  // 零碎名词
  get_secret_key: '获取密钥',
  history_session: '历史会话',
  remember_session: '记住会话',
  create_session: '创建会话',
  edit_session: '编辑会话',
  delete_session: '删除会话',
  user_type: '用户类型',
  authorized_user: '授权用户',
  root_account: '根账号',
  sub_account: '子账号',
  collaborator_id: '协作者',
  add_user: '添加用户',
  specified_domain: '指定域名',
  MAZ_configuration: '多 AZ 特性',
  MAZ_state: {
    MAZ: '已开启',
    OAZ: '已关闭',
    Off: '未开启',
    AccessDenied: '未知 (无HeadBucket权限)',
    Unknown: '未知',
  },

  // 存储桶
  bucket: [
    '存储桶', // 0
    '存储桶：{bucket}', // 1
  ],
  add_bucket: '添加桶',
  bucket_name: '存储桶名称',
  bucket_detial: '存储桶详情',
  switch_bucket: '切换存储桶',
  select_bucket: '选择存储桶',
  remote_folder: '存储桶目录',
  create_bucket: ['创建存储桶', '存储桶创建'],
  delete_bucket: ['删除存储桶', '存储桶删除'],
  edit_bucket: '编辑存储桶',
  edit_bucket_acl: '编辑存储桶 ACl 权限',
  edit_bucket_version_control: '编辑版本控制',

  // 标签
  tag: '标签',
  bucket_tag: '存储桶标签',
  tag_management: '标签管理',
  tag_key: '标签键',
  tag_value: '标签值',
  add_tags: '添加标签',
  tag_help: '标签管理使用帮助',
  delete_tag: '删除标签',
  set_tag: '设置标签',

  // 域名
  domain: '域名',
  domain_management: '域名管理',
  default_cdn_domain: '默认加速域名',
  current_status: '当前状态',
  acceleration_domain: '加速域名',
  acceleration_region: '加速地域',
  origin_server_type: '源站类型',
  origin_server_domain_name: '源站域名',
  origin_pull_authentication: '回源鉴权',
  CDN_authentication: 'CDN 鉴权',
  default_cdn_domain_help: '默认加速域名使用帮助',
  custom_cdn_domain_help: '自定义加速域名使用帮助',
  custom_cdn_domain_help_comment: [
    '注：请确保添加的域名已备案并已在DNS服务商处设置好对应的CNAME。',
    '更多帮助请参考',
  ],
  custom_domain_help: '自定义源站域名使用帮助',
  custom_domain_help_comment: [
    '注：该存储桶在中国大陆地区提供服务，请确保您的域名已完成备案，未备案的域名将无法作为自定义域名绑定到中国大陆的存储桶。',
    '同时，请在DNS服务商处设置好对应的CNAME记录，将请求路由至COS。',
    '更多帮助请参考',
  ],
  custom_cdn_domain: '自定义 CDN 加速域名',
  custom_domain: '自定义源站域名',
  domain_type: '源站类型',
  cname: 'CNAME',
  statu: '状态',
  speed_area_map: {
    mainland: '国内加速',
    overseas: '海外加速',
    global: '全球加速',
  },
  statu_map: {
    online: '已上线',
    offline: '未上线',
    processing: '部署中',
    rejected: '域名审核未通过，域名备案过期/被注销导致',
    ENABLED: '上线',
    DISABLED: '下线',
  },
  origin_type_map: {
    REST: '默认源站',
    cos: '默认源站',
    web: '静态网站源站',
    WEBSITE: '静态网站源站',
    ACCELERATE: '全球加速源站',
    V4_REST: '默认源站(旧)',
  },

  // 访问路径
  access_path: ['访问路径', '访问路径：{path}'],
  access_path_simple: '路径',
  add_access_path_simple: '添加路径',
  add_access_path: ['添加访问路径', '访问路径添加'],
  edit_access_path: '编辑访问路径',
  delete_access_path: ['删除访问路径', '访问路径删除'],

  show_in_local_folder: '在文件夹中显示',
  show_in_remote_folder: '在存储桶中显示',
  prefix_matching: '前缀匹配',

  region_name: '地域',
  endpoint: '请求域名',
  access_domain: '访问域名',
  bucket_domain: '存储桶域名',
  domainTypeMap: {
    defaultCos: '默认源站域名',
    defaultCdn: '默认加速域名',
    customCdn: '自定义加速域名',
    customCos: '自定义源站域名',
  },

  ETag: 'ETag',
  headers: 'Headers',

  // 对象
  object_url: '对象地址',
  copy_link_with_expires: '自定义复制链接',
  copy_link_without_sign: '复制不带签名的对象地址',
  copy_link_with_sign: '复制带签名的临时链接，指定有效时间',
  current_file_acl: '当前文件权限',
  loading_file_acl: '正在查询文件权限',
  copy_files: {
    msg: '已复制 {count} 项',
    success_without_sign: '对象地址复制成功，链接不带签名',
    success_with_sign: '临时链接复制成功，链接 {duration} {unit}有效',
    success: '{count} 个文件/文件夹粘贴成功',
    fail: '{count} 个文件/文件夹粘贴失败',
  },
  object_count: '对象数量',

  // 权限
  permission: '权限',
  public_permission: '公共权限',
  acl: '访问权限',
  acl_simple: 'ACL权限',
  public_pemission: '公共权限',
  acl_map: {
    'public-read-write': '公有读写',
    'public-read': '公有读私有写',
    private: '私有读写',
    default: '继承权限',
    'tce-default': '默认权限',
    AccessDenied: '未知 (无ACL获取权限)',
    Unknown: '未知',
    'unknown-with-timeout': '无法获取 (请自行选择链接类型)',
  },
  user_acl: '用户权限',
  set_user_acl: '设置用户权限',
  delete_user_acl: ' 删除用户权限',
  user_acl_map: {
    FULL_CONTROL: '完全控制',
    READ: '数据读取',
    WRITE: '数据写入',
    READ_ACP: '权限读取',
    WRITE_ACP: '权限写入',
  },
  edit_acl: '修改访问权限',
  permission_management: '权限管理',
  quick_auth: '快速授权',

  // 存储类型
  storage_class: '存储类型',
  storage_class_map: {
    STANDARD: '标准存储',
    STANDARD_IA: '低频存储',
    ARCHIVE: '归档存储',
    MAZ_STANDARD: '标准存储 (多AZ)',
    MAZ_STANDARD_IA: '低频存储 (多AZ)',
    NEARLINE: '近线存储',
  },
  storage_class_short_map: {
    STANDARD: '标准',
    STANDARD_IA: '低频',
    ARCHIVE: '归档',
    MAZ_STANDARD: '标准(多AZ)',
    MAZ_STANDARD_IA: '低频(多AZ)',
    NEARLINE: '近线',
  },
  edit_storage_class: '修改存储类型',

  // 版本控制
  version_control: '版本控制',
  versions: '历史版本',
  version_id: '版本号',
  version_map: {
    disabled: '从未启用',
    enabled: '已启用',
    suspended: '已暂停',
    accessdenied: '没权限获取',
    unknown: '未知',
  },
  deleted_flag: '删除标记',
  versioning_document: '版本控制文档说明',
  open_versioning: '开启版本控制',

  // 分块上传
  object_path: '对象路径',
  initiator_ID: '上传发起者 ID',
  owner_ID: '对象所有者 ID',
  uploaded_size: '已上传大小',
  uploaded_part_count: '已上传分块数',
  uploadId: '上传任务 ID',
  incomplete_multipart_upload: '文件碎片',
  clear_incomplete_uploads: '清空碎片',
  multipart_upload_name: '碎片名称',
  multipart_upload_path: '碎片路径',
  loading_incomplete_upload_info: '正在获取文件碎片信息...',

  // 格式校验
  validate: {
    invalid_input: '输入内容格式校验失败，请重新输入',
    path_name_length: '访问路径长度不能超过 255 个字符',
    folder_name_length: '文件夹名称不能超过 255 个字符',
    empty_folder_name: '文件夹名称不能为空',
    empty_file_name: '文件名称不能为空',
    invalid_char_in_folder_name: '文件夹不能包含以下字符：\\ / : * ? " < > |',
    bucket_name_format_simple: '仅支持小写字母、数字和 - 的组合，不能超过50字符',
    bucket_name_length: '存储桶名称长度不能超过50个字符',
    bucket_name_char: '存储桶名称必须由数字、小写字母和 - 组成',
    bucket_name_end_with: ['存储桶名称不能以 - 开头', '存储桶名称不能以 - 结尾'],
    bucket_name_format: '存储桶名称必须由数字、小写字母和 - 组成，长度不超过50个字符',
    secret_id_empty: 'SecretId 不能为空',
    secret_key_empty: 'SecretKey 不能为空',
    region_key_empty: '地域不能为空',
    secret_key_must_start_with_AKID: 'SecretId 开头必须是 AKID',
    secret_id_format: 'SecretId 字符数不对，应该是 36 字符',
    secret_key_format: 'SecretKey 字符数不对，应该是 32 字符',
    access_path_format:
      '格式为 Bucket 或 Bucket/Object-prefix，如 test-1250000000 或 test-1250000000/folder/',
    need_positive_int: '填写正整数',
    support_number_and_letters: '可用数字、英文的组合',
    support_char_most: '注：最多支持 {num} 个字符',
    empty_input_content: '输入内容不能为空',
    service_domain_format: 'Service域名格式错误',
    bucket_domain_format: 'Bucket域名格式错误',
    enter_account_id: '请输入添加的账号ID',
    invalid_account_id_format: '账号ID格式填写不正确',
    cannot_be_root_via_sub: '子账号类型时账号 ID 不能为根账号',
    choose_at_least_one_permission: '请至少选择一个用户权限',
    submit_new_user: '请先提交正在新增的用户',
    enter_a_full_tag_key_and_tag_value: '请填写完整标签键和标签值',
    tag_value_length_cannot_be_greater_than_255_characters: '标签值长度不能大于 255 字符',
    tag_key_length_cannot_be_greater_than_127_characters: '标签键长度不能大于 127 字符',
    tag_keys_cannot_begin_with: "标签键不能以'项目'、'project'、'qcs:' 开头",
    repetitive_tag_keys_are_not_allowed: '标签键不允许重复',
    share_valid_time: '最长有效时间为 2 小时',
    only_allow_integer: '请输入正整数',
    enter_6_extract_code: '请输入 6 位提取码',
    folder_name: [
      '文件夹名称不允许为空',
      '文件夹名称不能超过255个字符',
      '文件夹名称不能以 / 开头',
      '文件夹名称不能包含连续 / ',
      '文件夹名称不允许为 .. ',
      '当前路径总长度已超过850字节',
    ],
  },

  // 占位符
  placeholder: {
    file_prefix: '文件前缀',
    secret_id: '请输入 API 密钥 SecretID',
    secret_key: '请输入 API 密钥 SecretKey',
    add_path: '非必填，添加访问路径',
    add_remark: '非必填，添加备注名，用于账号管理',
    bucket: '格式如：test-1250000000',
    region: '格式如：ap-guangzhou',
    root_account_id: '请输入根账号ID',
    sub_account_id: '请输入子账号ID',
    collaborator_id: '请输入协作者账号ID',
    tag_key: '请输入标签键',
    tag_value: '请输入标签值',
  },

  // 提示
  tips: {
    whether_to_enter_access_path:
      '若当前账号拥有所有Bucket的权限，则无需输入访问路径；若当前账号只有某个存储桶或存储桶下某个目录的权限，则需要输入访问路径，格式为：Bucket或Bucket/Object-prefix，如test-1250000000',
    empty_bucket_list: '存储桶列表为空',
    create_bucket_in_console:
      '请在<a href="https://console.cloud.tencent.com" class="login-operate">控制台</a>创建存储桶',
    empty_file: '没有文件',
    history_session_empty: '没有历史会话记录',
    empty_history_file: '没有历史文件',
    empty_files_or_folders: '未选择文件/文件夹',
    delete_replication: '注意：当前存储桶有区域复制规则，删除操作会同步到目标存储桶',
    share_replication: '注意：当前存储桶有区域复制规则，在分享网页中进行的上传及删除操作会同步到目标存储桶',
    same_name_file_exist: '如果同名文件已存在：',
    access_path_describe:
      '访问路径可以为【某个存储桶】或【存储桶下的某个目录】，请确保添加的路径已被授权。\n 填写的存储桶路径必须为根账号名下的存储桶，同时请确保存储桶与地域的对应关系',
    private: '私有读写: 需要进行身份验证后才能对object进行访问操作。',
    'public-read': '公有读私有写: 可对object进行匿名读操作, 写操作需要进行身份验证。',
    'public-read-write': '可对object进行匿名读操作和写操作。',
    show_thumbnail_will_generate_CI_fee: '当前地域显示图片缩略图功能由数据万象服务提供技术支持，开启后可能会产生万象基础图片处理费用。',
    show_thumbnail_will_generate_download_traffic: '当前地域显示图片缩略图功能会下载完整图片，开启后可能会产生下载流量。',
    version_control_describe:
      '开启版本控制后，所有历史版本的同名文件将会被视为独立的对象处理，独占存储空间并产生存储容量费用。',
    clear_history_version: [
      '清空历史版本',
      '该操作将清空当前目录下全部对象的历史版本，请慎重操作！',
    ],

    read_bucket_ACL_permissions: '授予用户读取「存储桶访问权限」的权限',
    write_bucket_ACL_permissions: '授予用户写入「存储桶访问权限」的权限',
    read_object_ACL_permissions: '授予用户读取「对象访问权限」的权限',
    write_object_ACL_permissions: '授予用户写入「对象访问权限」的权限',

    choose_public_acl:
      '注意：公有读权限可以通过匿名身份直接读取您存储桶中的数据，存在一定的安全风险，为确保您的数据安全，不推荐此配置，建议您选择私有。',

    /**
     * empty file list different tips
     */
    // 1. 无存储桶权限
    no_access_to_bucket: '没有存储桶权限',
    concat_root_to_auth: '请联系主账号授权',
    // 2. 搜索无结果
    no_result_found: '未找到任何结果',
    try_diffrent_keyword: '尝试不同关键字',
    // 3. 文件夹为空
    empty_folder: '这个文件夹是空的',
    drag_here: '拖拽到这里即可上传',

    // 清空存储桶提示
    clear_bucket: [
      '清空存储桶将清空您桶内的所有对象，包括对象的历史版本和未完成上传碎片（',
      '清空后数据无法恢复',
      '），如您确认清空存储桶，请点击确认按钮执行。',
    ],
    object_count:
      '对象数量指存储桶中存在的对象数量。开启版本控制功能后，同名对象的历史版本都会以一个独立对象存在，会计入对象数量中。',
    specified_domain: '若已配置或添加相关域名，选择不同域名，对象地址会有相应的改变。',
    open_versions: ['如果您不希望文件被覆盖，可以 {open} 版本控制。', '开启'],
    MAZ_configuration: '开启多AZ特性后，提供同地域多个数据中心的容灾',
    tag_keys: '标签键区分大小写，支持 中文, a-z, A-Z, 0-9, +, -, _, =, /, ., :, @ 等字符',
    tag_values: '标签值区分大小写，支持 中文, a-z, A-Z, 0-9, +, -, _, =, /, ., :, @ 等字符',
    folder_name: [
      '1. 可用数字、中英文和可见字符的组合',
      '2. 用 / 分割路径，可快速创建子目录',
      '3. 不允许: 文件夹为空；连续 / ；以 / 开头',
      '4. 不允许以 .. 作为文件夹名称',
    ],
  },

  // 确认提示
  confirm: {
    authorized_actions: ['授权操作确认', '确定对账号 {id} 进行授权？'],
    delete_actions: ['删除操作确认', '确定删除对账号 {id} 的授权吗？'],
    exit: '有上传或下载任务正在进行，确定要停止任务并退出吗？',
    logout: '有上传或下载任务未完成，确定要清空任务并退出登录吗？',
    rename_cover: '存在同名文件，确定覆盖吗？',
    paste_param_cover: '{type}操作会覆盖同名文件，确定{type}吗？',
    paste_cover: '粘贴操作会覆盖同名文件，确定粘贴吗？',
    delete_files_or_folders: '删除操作不能恢复，确定要删除选中的文件或文件夹吗？',
    delete_task: '删除操作不能恢复，确定删除所有任务吗？',
    delete_access_path: '确定删除访问路径 {path} 吗？删除访问路径不影响文件，可以再次添加到菜单。',
    delete_bucket:
      '确定删除存储桶 {bucket} 吗？请确保存储桶下所有目录和文件已删空，删除后数据不可恢复和访问。',
    delete_a_version_object: '确定删除文件 "{name}" （版本日期为 {time}） 吗？',
    delete_some_version_object: '确定删除文件夹 "{name}" ？删除文件夹将清空该文件夹内的所有对象，包括对象的历史版本。注意：删除后数据不可恢复和访问。',
    delete_history_version_object: '确定清空当前目录下全部文件的历史版本吗？注意：删除后数据不可恢复和访问。',
    clear_bucket: [
      '确定清空当前所选的存储桶？',
      '清空存储桶将删除您存储桶中的所有文件及文件碎片，删除后数据不可恢复和访问。',
      '请输入存储桶名称',
      '以确认执行清空操作',
    ],
    pause_versioning: [
      '确定暂停版本控制？',
      '暂停仍将保留历史版本的对象，新上传的对象将以null版本存在。由于跨地域复制功能依赖版本控制，若暂停则跨地域复制会同时暂停。',
      '版本控制说明',
    ],
    delete_incomplete_uploads: '确认要删除路径为 {path} 的文件碎片吗？',
    clear_incomplete_uploads: '确定要清空该存储桶下所有的文件碎片吗？',
    delete_session: [
      '确定要删除会话 {name} 吗？',
      '确定要删除会话 {name} 下的访问路径 "{path}" 吗？',
    ],
    delete_not_exist_sub_account: '子账号 {subUin} 不存在，确认将删除子账号的授权。',
    check_remember: '取消勾选会将该条会话记录（包括访问路径）全部删除。',
    delete_tag: '确认要删除标签 {tag}',
  },

  /**
   * 统计弹窗
   */
  statistics_alert: [
    '该页面数据由云监控提供，数据可能存在延迟。该数据仅作为监控数据以供参考，准确的计费计量数据可到',
    '费用中心',
    '中查看',
  ],

  /**
   *
   * 设置页面
   *
   * */
  reset_default: '还原默认值',

  // 账号配置
  account: '账号',

  // 关于配置
  about: '关于',
  cosBrowser: 'COSBrowser - 腾讯云 COS 客户端',
  version_update: '版本更新',
  has_new_version: '新版本',
  no_new_version: '已是最新',
  check_update: '检查更新',
  update_now: '立即更新',
  update_tip: ['获取到新版本，是否立即更新？', '软件有新版本，是否立即更新？'],
  get_update: '获取更新',
  updating: '正在下载最新版本...',
  update_downloaded: '最新版本已下载完成！',
  update_restart_app: '需要重启才生效，确认重启当前软件吗？',
  feedback: '问题反馈',
  instructions: '使用说明',
  update_log: '更新日志',
  local_log: '本地日志',
  privacy_policy: '隐私协议',
  copyright: `2017-${new Date().getFullYear()} Tencent. All Rights Reserved.`,

  // 通用配置
  general: '通用',
  language: '语言',
  service_domain: 'EndPoint/Service域名',
  service_domain_placeholder: '默认不填',
  service_domain_tip: '用作 GetService 的域名\n例子: cos.ap-beijing.myqcloud.com\n默认不填',
  bucket_domain_setting: 'Bucket域名模板',
  bucket_domain_tip:
    '用作 Bucket 请求的域名模版\n支持模板参数 {Bucket} 和 {Region}\n例子：{Bucket}.cos.{Region}.myqcloud.com\n默认不填',
  force_use_https: '使用 HTTPS',
  not_use_https: '不使用 HTTPS',
  strict_ssl: '校验 HTTPS 证书',
  ignore_ssl_error: '忽略 HTTPS 证书错误',
  auto_update: '自动更新',
  path_style: '使用后缀式',
  path_style_tip:
    '后缀式存储桶名称不再作为域名前缀，会放在请求路径里\n存储桶名称也参与签名，例如上传文件到 test-1250000000 的格式是：\nPUT https://cos.ap-beijing.myqcloud.com/test-1250000000/1.jpg\n/test-1250000000/1.jpg 会作为签名的 pathname 参与签名计算。',

  // 代理配置
  proxyType: '代理类型',
  proxy: '代理',
  no_proxy: '不使用代理，直连网络',
  system_proxy: '使用系统代理',
  custom_proxy: '使用自定义代理',

  // 上传配置
  file_parallel_limit: '文件并发数',
  chunk_parallel_limit: '分块并发数',
  chunk_retry_times: '失败重试次数',
  chunk_retry_interval: '失败重试间隔',
  upload_double_check: '上传完二次校验',
  upload_double_check_tips: '(上传完成后，获取对象信息，对比本地文件)',
  upload_add_meta_md5: '计算并添加 x-cos-meta-md5 头部 (增加耗时)',
  upload_add_meta_md5_tips: '(用于在其他渠道下载对象时，校验完成性)',

  // 下载配置
  change_location_tip: '更改位置',
  ask_before_download: '下载前，询问保存位置',
  download_to_location: '下载到指定位置',

  // 【上传】对象标签
  object_tag: '对象标签',

  // 从组件中提取的中文内容
  // 头部导航
  transfer: '传输',
  view_on_mobile_app: '在手机 APP 查看',
  switch_to_english: '切换到英文',
  switch_to_chinese: '切换到中文',
  open_in_cos_client: '在 COS 客户端查看',
  cos_client_not_detected: '未检测到COS客户端，将为您跳转至COSBrowser下载页面',

  // 分页组件
  selected_items: '已选',
  items: '项',
  pulled_items: '已拉取',
  rows_per_page: '每页显示行',
  page: '第',
  page_number: '页',
  previous_page: '上一页',
  next_page: '下一页',

  // 文件表格
  size: '大小',
  modify_time: '修改时间',
  operation: '操作',
  no_permission: '没有权限',
  link_expired: '当前链接已失效',
  no_results_found: '未找到任何结果',
  try_different_keywords: '尝试不同关键字',
  folder_is_empty: '这个文件夹是空的',

  // 高级上传
  upload_files: '上传文件',
  select_upload_object: '选择上传对象',
  set_object_properties: '设置对象属性',
  select_files: '选择文件',
  select_folder: '选择文件夹',
  file_folder: '文件/文件夹',
  delete: '删除',
  no_files_selected: '未选择文件/文件夹',
  drag_upload_tip: 'Chrome 和 FireFox 支持拖拽到此区域上传，支持选择多个文件/文件夹<br>单个文件最大支持 512GB',
  object_properties_tip: '对象属性设置将应用到所有待上传的对象上，您也可上传完成后在文件列表页直接设置。',
  storage_type: '存储类型',
  standard_storage_maz: '标准存储 (多AZ)',
  low_frequency_storage_maz: '低频存储 (多AZ)',
  standard_storage: '标准存储',
  low_frequency_storage: '低频存储',
  archive_storage: '归档存储',
  access_permission: '访问权限',
  inherit_permission: '继承权限',
  private_read_write: '私有读写',
  public_read_private_write: '公有读私有写',
  storage_method: '存储方式',
  if_same_name_file_exists: '如果同名文件已存在',
  overwrite: '覆盖',
  rename: '重命名',
  skip: '跳过',
  object_tags: '对象标签',
  metadata: '元数据',
  parameter: '参数',
  value: '值',
  select_project: '选择项目',
  add_parameter: '添加参数',
  next_step: '下一步',
  previous_step: '上一步',
  upload: '上传',

  // 速度测试
  upload_domain_config: '上传域名测配置',
  default_domain: '默认域名',
  global_acceleration_domain: '全球加速域名',
  need_enable_global_acceleration: '（需开启存储桶全球加速功能）',
  enter_custom_domain: '输入自定义域名，如：www.example.com',
  download_domain_config: '下载域名测配置',
  speed_test_tip: '提示：测速过程中会在存储桶中上传一个临时文件，测速完成后会自动删除',
  start_speed_test: '开始测速',

  // 传输列表
  name: '名称',
  status: '状态',
  waiting_upload: '等待上传',
  file_checking: '文件校验中',
  upload_success: '上传成功',
  upload_failed: '上传失败',
  upload_paused: '暂停上传',
  remaining: '剩余',
  pause: '暂停',
  start: '开始',
  retry: '重试',
  cancel: '取消',
  clear_completed: '清除已完成',
  more: '更多',
  pause_all: '暂停全部',
  start_all: '开始全部',
  delete_all: '删除全部',
  uploading: '上传',
  upload_failed_text: '上传失败',
  upload_success_text: '上传成功',

  // 桌面组件
  extract: '提取',
  prefix_search: '前缀搜索',

  // 标签工具
  enter_tag_key: '请输入标签键',
  enter_tag_value: '请输入标签值',
  tag_limit_10: '标签数量最多为 10',

  // 面包屑导航
  all_files: '全部文件',
  // 下载提示
  open_in_safari_to_download: '请点击右上角，在Safari中打开再进行下载',
  // 标签工具
  // 文件大小限制
  file_size_exceeds_limit: '大小超过限制，仅允许上传 {maxSize} 以内的文件',
  // 错误消息
  current_share_link_does_not_exist: '当前分享链接不存在',
  current_share_link_has_expired: '当前分享链接已失效',
  extract_code_error_please_re_enter: '提取码错误，请重新输入',
  decoding_failed_please_try_again: '解码失败，请重试',
  please_enter_6_digit_extract_code: '请输入 6 位的提取码',
  network_busy_please_refresh_page: '网络繁忙，请刷新页面',
  // 文件检查
  checking_files: '正在检查文件...',
  // 错误消息
  no_files_to_upload: '没有需要上传的文件',
  root_directory_prefix_search_not_allowed: '根目录下不允许进行前缀搜索',
  // 速度测试
  please_enter_speed_test_parameters: '请输入测速参数',
  speed_test_parameter_exception: '测速参数异常',
  speed_test_in_progress_please_wait: '正在测速中，请稍等',
  please_enter_custom_upload_domain: '请输入上传自定义域名',
  please_enter_custom_download_domain: '请输入下载自定义域名',
  // 速度测试状态
  upload_speed_test_in_progress: '上传测速中',
  upload_speed_test_in_progress_with_percent: '上传测速中（{percent}）',
  upload_speed_test_completed: '上传测速完成',
  upload_speed_test_failed: '上传测速失败',
  upload_speed_test_failed_link_expired_please_re_acquire: '上传测速失败：测速链接已失效，请重新获取',
  upload_speed_test_failed_prefix: '上传测速失败：',
  download_speed_test_in_progress: '下载测速中',
  download_speed_test_completed: '下载测速完成',
  download_speed_test_failed: '下载测速失败：',
  download_speed_test_failed_prefix: '下载测速失败：',
  upload_completed: '上传完成',
  download_completed: '下载完成',
  // 速度测试指标
  slowest: '最慢',
  fastest: '最快',
  average: '平均',
};
